// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:wght@500;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_App__cZp\\+K {
  display: flex;
  align-content: flex-start;
  flex: 1 1;
  overflow: hidden;
  height: 100vh;
}

.styles_tableContainer__qTz\\+A {
  background: var(--gray-100, #f5f5f5);
  padding: 10px;
  flex: 1 1;
  padding-left: 24px;
  padding-top: 12px;
  width: 80% !important;
}

.styles_sidebarContainer__K1QcH {
  width: 12% !important;
}

.styles_logoutButton__YJETw {
  position: absolute;
  bottom: 20px;
  left: 50px;
  z-index: 1500;
}

.styles_sidebarLogo__A5-Ma {
  max-width: 120px;
  width: 100%;
  height: auto;
}

@media screen and (max-width: 1720px) {
  .styles_tableContainer__qTz\\+A {
    width: 79% !important;
  }
  .styles_sidebarContainer__K1QcH {
    width: 10% !important;
  }
}
@media screen and (max-width: 1536px) {
  .styles_tableContainer__qTz\\+A {
    width: 78% !important;
  }
  .styles_sidebarContainer__K1QcH {
    width: 11% !important;
  }
}
@media screen and (max-width: 1440px) {
  .styles_tableContainer__qTz\\+A {
    width: 77% !important;
  }
  .styles_sidebarContainer__K1QcH {
    width: 12% !important;
  }
}
@media screen and (max-width: 1300px) {
  .styles_tableContainer__qTz\\+A {
    width: 76% !important;
  }
  .styles_sidebarContainer__K1QcH {
    width: 13% !important;
  }
}
@media screen and (max-width: 1200px) {
  .styles_tableContainer__qTz\\+A {
    width: 75% !important;
  }
  .styles_sidebarContainer__K1QcH {
    width: 14% !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/layout/styles.module.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,yBAAA;EACA,SAAA;EACA,gBAAA;EACA,aAAA;AAAF;;AAGA;EACE,oCAAA;EACA,aAAA;EACA,SAAA;EACA,kBAAA;EACA,iBAAA;EACA,qBAAA;AAAF;;AAGA;EACE,qBAAA;AAAF;;AAGA;EACE,kBAAA;EACA,YAAA;EACA,UAAA;EACA,aAAA;AAAF;;AAGA;EACE,gBAAA;EACA,WAAA;EACA,YAAA;AAAF;;AAGA;EACE;IACE,qBAAA;EAAF;EAGA;IACE,qBAAA;EADF;AACF;AAIA;EACE;IACE,qBAAA;EAFF;EAKA;IACE,qBAAA;EAHF;AACF;AAMA;EACE;IACE,qBAAA;EAJF;EAOA;IACE,qBAAA;EALF;AACF;AAQA;EACE;IACE,qBAAA;EANF;EASA;IACE,qBAAA;EAPF;AACF;AAUA;EACE;IACE,qBAAA;EARF;EAWA;IACE,qBAAA;EATF;AACF","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Poppins:wght@500;600;700&display=swap\");\n\n.App {\n  display: flex;\n  align-content: flex-start;\n  flex: 1;\n  overflow: hidden;\n  height: 100vh;\n}\n\n.tableContainer {\n  background: var(--gray-100, #f5f5f5);\n  padding: 10px;\n  flex: 1;\n  padding-left: 24px;\n  padding-top: 12px;\n  width: 80% !important;\n}\n\n.sidebarContainer {\n  width: 12% !important;\n}\n\n.logoutButton {\n  position: absolute;\n  bottom: 20px;\n  left: 50px;\n  z-index: 1500;\n}\n\n.sidebarLogo {\n  max-width: 120px;\n  width: 100%;\n  height: auto;\n}\n\n@media screen and (max-width: 1720px) {\n  .tableContainer {\n    width: 79% !important;\n  }\n\n  .sidebarContainer {\n    width: 10% !important;\n  }\n}\n\n@media screen and (max-width: 1536px) {\n  .tableContainer {\n    width: 78% !important;\n  }\n\n  .sidebarContainer {\n    width: 11% !important;\n  }\n}\n\n@media screen and (max-width: 1440px) {\n  .tableContainer {\n    width: 77% !important;\n  }\n\n  .sidebarContainer {\n    width: 12% !important;\n  }\n}\n\n@media screen and (max-width: 1300px) {\n  .tableContainer {\n    width: 76% !important;\n  }\n\n  .sidebarContainer {\n    width: 13% !important;\n  }\n}\n\n@media screen and (max-width: 1200px) {\n  .tableContainer {\n    width: 75% !important;\n  }\n\n  .sidebarContainer {\n    width: 14% !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"App": `styles_App__cZp+K`,
	"tableContainer": `styles_tableContainer__qTz+A`,
	"sidebarContainer": `styles_sidebarContainer__K1QcH`,
	"logoutButton": `styles_logoutButton__YJETw`,
	"sidebarLogo": `styles_sidebarLogo__A5-Ma`
};
export default ___CSS_LOADER_EXPORT___;
